<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .lead-tag-tooltip {
    @include salesflow-label($color: #FFF, $font-weight: 600);
  }

  .lead-tags {
    background-color: rgba(153, 75, 254, 0);
    margin: 0 -20px;
    padding: 0;
    border-radius: 5px;

    .multiselect {
      padding: 1rem 0;
    }

    .multiselect__tags {
      height: unset;
      min-height: 0px;
      padding: 1rem 0;
      border: none;
      display: flex;
      flex-flow: column;

      .multiselect__tags-wrap {
        font-size: 0.75rem;
        font-weight: 500;
        padding: 0 1.2rem;
        order: 2;


        .multiselect__tag {
          color: $white;
          background: $salesflow-primary;
          line-height: 1.125rem;
          padding: 6px 1.5625rem 6px 0.75rem;
          margin-right: 7px;
          margin-bottom: 7px;
          border-radius: 8px;
          vertical-align: middle;
          width: 100%;

          &:hover {
            cursor: pointer;
            background-color: $salesflow-primary-hover;
          }

          span {
            margin-right: 0.25rem;
          }

          .multiselect__tag-icon {
            width: 25px;
            line-height: 0px;
            margin: 0;
            display:flex;
            align-items: center;

            &:after {
              color: $white;
              font-size: 0.75rem;
              font-weight: 500;
              content: 'x';
            }

            &:hover {
              background: rgba(0,0,0,0);
            }
          }
        }
      }

      .multiselect__input {
        height: unset;
        width: 80% !important;
        color: $gray-dark;
        background-color: rgba(153, 75, 254, 0);
        font-size: 0.75rem;
        line-height: 30px;
        padding: 0;
        margin-left: 19px;
        position: relative !important;
        order: 1;
        cursor: pointer;

        &:focus{
          background-color: rgba(153, 75, 254, 0);
          cursor:text;
        }
      }

      .multiselect__placeholder {
        color: $gray-light;
        font-size: 0.75rem;
        line-height: 30px;
        padding: 0 1.2rem;
        margin: 0;
        display: none;
      }

      .multiselect__spinner {
        background: transparent;
        height: 100%;
      }
    }

    .multiselect__content-wrapper {
      border: 0;
      margin: 0.75rem 0.25rem;
      box-shadow: 0 0 15px rgba(103, 70, 162, 0.18);

      .multiselect__content {
        display: block !important;

        .multiselect__option {
          height: 52px;
          line-height: 30px;
          padding: 0 1.2rem;
        }

        .multiselect__option:after {
          background: $green;
          font-weight: 500;
          line-height: 52px;
        }
      }

      &:before {
        display: none;
      }
    }
  }
</style>

<template>
  <div
    class="lead-tags"
    v-show="show"
  >
    <Multiselect
      v-model="tags"
      placeholder="Adicionar Tag"
      tag-placeholder="Criar tag"
      :options="options"
      :multiple="true"
      :taggable="true"
      :show-labels="false"
      :hide-selected="true"
      :preserve-search="true"
      :show-no-options="false"
      :show-no-results="false"
      @input="update"
      @tag="add"
    >
      <template
        slot="selection"
        slot-scope="{ values, search, isOpen, remove }"
      >
        <div class="multiselect__tags-wrap">
          <span
            class="multiselect__tag"
            v-for="value in values"
            :key="value"
            :style="'background:' + value.color"
            v-b-tooltip.right="{
              customClass: 'ml-2 lead-tag-tooltip'
            }"
            :title="value"
          >
            <span>
              {{ value }}
            </span
            >
            <i
              aria-hidden="true"
              tabindex="1"
              class="multiselect__tag-icon"
              @click="remove(value)"
            ></i>
          </span>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  props: ['hash', 'leadTags'],

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      show: false,
      tags: this.leadTags.map((tag) => tag.name),
      options: [],
    };
  },

  created () {
    this.getTags();
  },

  methods: {
    update (tags) {
      this.$http.put(`/lead/${this.hash}/tag`, { tags: tags.join(',') });
    },

    add (tag) {
      this.tags.push(tag);
      this.options.push(tag);

      this.update(this.tags);
    },

    getTags () {
      this.$http.get('/tag')
        .then(({ data }) => {
          this.options = data.map((tag) => tag.name);
          this.show = true;
        });
    },
  },
};
</script>
